import { ColumnFiltersState } from "@tanstack/react-table";

// Define the structure of the filter query
interface FilterQuery {
  filter: Record<string, any>;
}

export const formatFilters = (columnFilters: ColumnFiltersState) => {
  const filterQuery: FilterQuery = { filter: {} };

  columnFilters.forEach((filter) => {
    const values = filter.value as string[];
    if (!values?.length) return;

    // If multiple values exist for the same field, use $in
    if (values.length > 1) {
      filterQuery.filter[filter.id] = { $in: values };
    } else {
      // filterQuery.filter[filter.id] = { $eq: values[0] };
      filterQuery.filter[filter.id] = values[0];
    }
  });

  return filterQuery;
};
